import { createFileRoute } from '@tanstack/react-router'
import FrontDesk from '@/features/frontdesk'

export const Route = createFileRoute('/_authenticated/dashboard/frontdesk')({
  component: FrontDesk,
})
